import { render, staticRenderFns } from "./ReservationSettingPeriodForm.vue?vue&type=template&id=70074680&"
import script from "./ReservationSettingPeriodForm.vue?vue&type=script&lang=js&"
export * from "./ReservationSettingPeriodForm.vue?vue&type=script&lang=js&"
import style0 from "./ReservationSettingPeriodForm.vue?vue&type=style&index=0&lang=scss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports